export const SNCR_API_DEFAULT =
  "https://api-gateway.hmg.apps.anvisa.gov.br/api-sncr/api/v1";

export const SNCR_CONSULTA_RECEITA_BASE =
  "https://sncr.anvisa.gov.br/receita/consultar";

export function buildSncrConsultaUrl(numero: string): string {
  const n = (numero || "").trim();
  return `${SNCR_CONSULTA_RECEITA_BASE}?numero=${encodeURIComponent(n)}`;
}

export const SNCR_STORAGE = {
  accessToken: "sncr_auth_token",
  exchangeLock: "sncr_session_exchange_lock",
  lastResult: "sncr_last_auth_result",
} as const;

export const SNCR_NOTIFICACAO_TIPOS = [
  "NRA",
  "NRB",
  "NRB2",
  "NRR",
  "NRT",
] as const;

export const SNCR_RETENCAO_TIPOS = ["RCE", "RET"] as const;

export const SNCR_RETENCAO_CNPJ = "05490544000100";

export const SNCR_NUMERACAO_TIPOS = [
  ...SNCR_NOTIFICACAO_TIPOS,
  ...SNCR_RETENCAO_TIPOS,
] as const;

export const SNCR_NUMERACAO_TIPO_LABELS: Record<
  (typeof SNCR_NUMERACAO_TIPOS)[number],
  string
> = {
  NRA: "Notificação de Receita A",
  NRB: "Notificação de Receita B",
  NRB2: "Notificação de Receita B2",
  NRR: "Notificação de Receita Especial (Retinoides)",
  NRT: "Notificação de Receita Talidomida",
  RCE: "Receita de Controle Especial",
  RET: "Receita sujeita à Retenção",
};

export const SNCR_NOTIFICACAO_TIPO_LABELS = SNCR_NUMERACAO_TIPO_LABELS;

export function sncrTipoLabel(
  tipo: (typeof SNCR_NUMERACAO_TIPOS)[number] | "ALL",
): string {
  if (tipo === "ALL") return "Todos";
  const nome = SNCR_NUMERACAO_TIPO_LABELS[tipo];
  return nome ? `${tipo} — ${nome}` : tipo;
}

export function isSncrRetencaoTipo(
  tipo: string,
): tipo is (typeof SNCR_RETENCAO_TIPOS)[number] {
  return (SNCR_RETENCAO_TIPOS as readonly string[]).includes(tipo);
}

export function isSncrNotificacaoTipo(
  tipo: string,
): tipo is (typeof SNCR_NOTIFICACAO_TIPOS)[number] {
  return (SNCR_NOTIFICACAO_TIPOS as readonly string[]).includes(tipo);
}

export const SNCR_CONSELHOS = ["CRM", "CRMV", "CRO"] as const;

export const SNCR_NOTIFICACAO_QTD = {
  min: 10,
  max: 50,
  default: 10,
  dailyLimit: 50,
} as const;

export const SNCR_RETENCAO_QTD = {
  perRequest: 1000,
  monthlyLimit: 3000,
} as const;

export function sncrQuotaTooltip(
  tipo: (typeof SNCR_NUMERACAO_TIPOS)[number] | string,
): string {
  if (isSncrRetencaoTipo(tipo)) {
    return `Cota de ${tipo}: ${SNCR_RETENCAO_QTD.perRequest} números por requisição. Limite de ${SNCR_RETENCAO_QTD.monthlyLimit} por mês.`;
  }
  return `Cota de ${tipo}: até ${SNCR_NOTIFICACAO_QTD.dailyLimit} números por dia.`;
}

export const SNCR_BASIC = {
  profile: "http://fluxmed.cloud/fhir/StructureDefinition/SncrNumeracaoNotificacao",
  codeSystem: "http://fluxmed.cloud/fhir/CodeSystem/basic-resource-type",
  code: "SNCR_NUMERACAO_NOTIFICACAO",
  extensions: {
    tipoReceita: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-tipo-receita",
    inicio: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-faixa-inicio",
    fim: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-faixa-fim",
    quantidade: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-quantidade",
    saldoReceitas: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-saldo-receitas",
    status: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-status",
    conselho: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-conselho",
    uf: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-uf",
    documento: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-documento",
    numeros: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-numeros",
    numerosUsados: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-numeros-usados",
    mensagemApi: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-mensagem-api",
    lotes: "http://fluxmed.cloud/fhir/StructureDefinition/sncr-lotes",
  },
} as const;
